export default "__VITE_ASSET__B9Tj_T$V__"